import {CONTRIBUTORS} from 'data/CONTRIBUTORS'

export const changelog = [
	{
		date: new Date('2025-04-11'),
		Changes: () => <>Update AoE breakpoints for patch 7.2.</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-06-30'),
		Changes: () => <>Update Machinist data and modules for Dawntrail.</>,
		contributors: [CONTRIBUTORS.HINT],
	},
]
